import { CSS }              from '@dnd-kit/utilities';
import { SortableListItem } from '../../SortableList';
import { Text }             from '@chakra-ui/react';
import { useSortable }      from '@dnd-kit/sortable';

interface ISortableItemProps {
	dragIcon?: React.ReactNode;
	item: SortableListItem;
	index: number;
	listLength: number;
}

const SortableItem = (props: ISortableItemProps) => {
	const { dragIcon, item, index, listLength } = props;
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({id: item.id});

	const position = index + 1;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		display: 'flex',
		alignItems: 'center',
		touchAction: 'none',
		cursor: isDragging ? 'grabbing' : 'grab',
		borderBottom: position === listLength ? 'unset' : '2px solid #00000026',
		borderTop: '',
		backgroundColor: isDragging ? '#F1F2F1' : 'unset'
	};

	return (
		<div 
			ref={setNodeRef} 
			style={style} 
			{...attributes} 
			{...listeners}
		>
			{dragIcon && <div style={{ marginBottom: "3px", marginRight: "10px" }} >{dragIcon}</div>}
			{typeof position === 'number' && <Text className='poppins-semibold' marginRight="15px" width="10px">{position}</Text>}
			{item.render()}
		</div>
	)
}

export default SortableItem